<div #doubleBarChart class="md-12 is-graph" id="DRA" [chart]="chart"></div>
<div class="mt-3">
    <div style="display: inline-block" *ngFor="let data of extraData">
        <div class="ml-5 data">{{ data.data != 0 ? data.data : '-' }}</div>
        <div class="ml-2 description"> {{ data.description }}</div>
    </div>
</div>